import React from 'react';
import { Descriptions } from 'antd';
import CardView from '@/components/Card';
import Price from '@/components/Price';
import styles from '../style.less';
import { PreOrder } from '@/models/order';
import { CarryOutTwoTone, FallOutlined } from '@ant-design/icons';
import WaiverAmountSelector from '../WaiverAmountSelector';
import { useSettlementStore } from '../store/useSettlementStore';

type Props = {
  cards: PreOrder['cards'];
};

/**
 * 购买套餐卡交易明细展示区域
 * 
 * 订阅 Zustand Store 中的抹零金额与最终合计总额。
 */
const CardTradeArea: React.FC<Props> = ({ cards }: Props) => {
  const beforeTotalPrice = useSettlementStore(s => s.beforeTotalPrice);
  const waiverAmount = useSettlementStore(s => s.waiverAmount);
  const setWaiverAmount = useSettlementStore(s => s.setWaiverAmount);
  const totalPrice = useSettlementStore(s => s.totalPrice);

  return (
    <>
      <div className={styles.item}>
        <h3>
          <FallOutlined /> 特殊减免
        </h3>
        <div>
          <WaiverAmountSelector
            value={Number(waiverAmount || 0)}
            onChange={val => setWaiverAmount(val)}
            beforeTotalPrice={beforeTotalPrice}
          />
        </div>
      </div>

      <div className={styles.item}>
        <h3>
          <CarryOutTwoTone /> 交易清单如下，请收款
        </h3>
        <div>
          <Descriptions column={2} size={'small'} layout="vertical" bordered>
            <Descriptions.Item label="套餐卡" span={2}>
              {cards.map((card, index) => (
                <CardView key={`${card.id}-${index}`} card={card} />
              ))}
            </Descriptions.Item>
            {Boolean(waiverAmount) && (
              <Descriptions.Item span={2} label="特殊减免">
                <Price value={waiverAmount} negative />
              </Descriptions.Item>
            )}
            <Descriptions.Item label="合计应收额" span={2}>
              <Price value={totalPrice} />
            </Descriptions.Item>
          </Descriptions>
        </div>
      </div>
    </>
  );
};

export default CardTradeArea;
